import api, { type ApiResponse, type PageResponse } from './api'

const ANNOUNCEMENT_CHANGED_EVENT = 'kyren:announcement-changed'

export const notifyAnnouncementChanged = () => window.dispatchEvent(new Event(ANNOUNCEMENT_CHANGED_EVENT))
export const subscribeAnnouncementChanges = (listener: () => void) => {
  window.addEventListener(ANNOUNCEMENT_CHANGED_EVENT, listener)
  return () => window.removeEventListener(ANNOUNCEMENT_CHANGED_EVENT, listener)
}

export type AnnouncementPriority = 'NORMAL' | 'IMPORTANT' | 'URGENT'

export interface AnnouncementItem {
  id: string
  title: string
  content: string
  priority: AnnouncementPriority
  visibleAt: number
  expiresAt?: number | null
  readAt?: number | null
  confirmedAt?: number | null
}

export interface AnnouncementSummary {
  unreadCount: number
  importantAnnouncement?: AnnouncementItem
  urgentAnnouncement?: AnnouncementItem
}

export const getAnnouncementSummary = (): Promise<ApiResponse<AnnouncementSummary>> => api.get('/v1/merchant/announcement-inbox/summary')
export const listInboxAnnouncements = (params: Record<string, unknown>): Promise<ApiResponse<PageResponse<AnnouncementItem>>> => api.get('/v1/merchant/announcement-inbox', { params })
export const getInboxAnnouncement = (id: string): Promise<ApiResponse<AnnouncementItem>> => api.get(`/v1/merchant/announcement-inbox/${id}`)
export const markAnnouncementRead = (id: string): Promise<ApiResponse<{ announcementId: string; readAt: number }>> => api.post(`/v1/merchant/announcement-inbox/${id}/read`)
export const confirmAnnouncement = (id: string): Promise<ApiResponse<{ announcementId: string; readAt: number; confirmedAt: number }>> => api.post(`/v1/merchant/announcement-inbox/${id}/confirm`)
